import { render, staticRenderFns } from "./cdbList.vue?vue&type=template&id=dda5f316&"
import script from "./cdbList.vue?vue&type=script&lang=js&"
export * from "./cdbList.vue?vue&type=script&lang=js&"
import style0 from "./cdbList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports